export const cleanLoandiskUniqueNumber = (value: string | null | undefined): string =>
  String(value || '')
    .trim()
    .replace(/^#+\s*/, '');

export const normalizeLoandiskUniqueNumber = (value: string | null | undefined): string =>
  cleanLoandiskUniqueNumber(value).replace(/\s*-\s*/g, '-');

export const loandiskUniqueNumberKey = (value: string | null | undefined): string =>
  normalizeLoandiskUniqueNumber(value).toLocaleLowerCase('en-US');

export const collectionCaseKey = (
  id: string,
  uniqueNumber: string | null | undefined
): string => {
  const loandiskKey = loandiskUniqueNumberKey(uniqueNumber);
  return loandiskKey ? `loandisk:${loandiskKey}` : `legacy:${id}`;
};

// Queries are ordered newest-first on collector pages. Preserve the first row
// for each LoanDisk identity so historical manual/backfilled rows do not appear
// as duplicate borrowers.
export const dedupeCollectionCases = <
  T extends { id: string; loandisk_id?: string | null }
>(items: T[]): T[] => {
  const unique = new Map<string, T>();
  items.forEach((item) => {
    const key = collectionCaseKey(item.id, item.loandisk_id);
    if (!unique.has(key)) unique.set(key, item);
  });
  return Array.from(unique.values());
};
